import React, { JSX } from 'react';
import {
  ImageField,
  Field,
  LinkField,
  Link,
  Image,
  RichText,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import VideoPlayer from 'components/molecules/VideoPlayer';

type VideoFeatureCardProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    Headline: Field<string>;
    BodyCopy: RichTextField;
    Thumbnail: ImageField;
    VideoUrl: Field<string>;
    Logo: ImageField;
    BadgeText: Field<string>;
    CTA: LinkField;
    BasePhoneNumber: Field<string>;
  };
};

const VideoFeatureCard = (props: VideoFeatureCardProps): JSX.Element => {
  if (props.fields == undefined || !props.fields.Headline) {
    return <div>Data source is not defined</div>;
  }

  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );

  const { Headline, BodyCopy, Thumbnail, VideoUrl, Logo, BadgeText, CTA, BasePhoneNumber, } =
    props.fields;

  const hasLogo = Boolean(Logo?.value?.src);
  const hasBadgeText = Boolean(BadgeText?.value?.trim());
  const hasLogoLockup = hasLogo || hasBadgeText;
  const phoneNumber = BasePhoneNumber?.value?.trim();
  const ctaText = CTA?.value?.text?.trim();

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`video-feature-card-${props.rendering?.uid}`}
    >
      <div className="video-feature-card">
        <div className="jss-inner-container">
          <div className="card">
            <VideoPlayer
              VideoUrl={VideoUrl}
              Thumbnail={Thumbnail}
              allowFullScreen
            />
            <div className={classNames('card-content')}>
              {hasLogoLockup && (
                <div className="logo-lockup">
                  {hasLogo && (
                    <div className="logo">
                      <Image field={Logo} />
                    </div>
                  )}
                  {hasLogo && hasBadgeText && <div className="divider"></div>}

                  {hasBadgeText && (
                    <div className="badge">{BadgeText.value}</div>
                  )}
                </div>
              )}
              {Headline?.value && (
                <h2 className="heading osf-display-h2">{Headline.value}</h2>
              )}
              {BodyCopy?.value && (
                <div className="description osf-body-copy">
                  <RichText field={BodyCopy} />
                </div>
              )}
              {phoneNumber ? (
                <a
                  href={`tel:${phoneNumber}`}
                  className={classNames('btn-link btn-primary')}
                >
                  {ctaText || phoneNumber}
                </a>
              ) : (
                CTA?.value?.href && (
                  <Link
                    className={classNames('btn-link btn-primary')}
                    field={CTA}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoFeatureCard;
